// Institute of Design and Innovation (email idi@unm.edu). //

import store from '../store/store'
import SessionService from '@/common/sessionService'
import { RouteLocation } from 'vue-router'

/** Path names that do not require login */
const whitelist = { Login: true, NotFound: true }

/**
 * Navigation guard that requires the user to be logged in
 */
export default async function (to: RouteLocation, from: RouteLocation, next) {
  sessionStorage.setItem('reload_path', to.path)

  if (!store.state.userId && !whitelist[to.name as string]) {
    SessionService.redirectToLoginProvider()
    // const loggedIn = await SessionService.initializeSession()
    // if (loggedIn) {
    //   next()
    // } else {
    //   SessionService.redirectToLoginProvider()
    // }
  } else {
    next()
  }
}
